// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AiAccessRouteImport } from './routes/ai-access'
import { Route as AiPredictionsRouteImport } from './routes/ai-predictions'
import { Route as AnalysisRouteImport } from './routes/analysis'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BestFootballPredictionSiteRouteImport } from './routes/best-football-prediction-site'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CreditReceiptsRouteImport } from './routes/credit-receipts'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as HighOddsRouteImport } from './routes/high-odds'
import { Route as HistoricalOddsRouteImport } from './routes/historical-odds'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as JackpotPredictionsRouteImport } from './routes/jackpot-predictions'
import { Route as MatchCurationRouteImport } from './routes/match-curation'
import { Route as MatchPreviewRouteImport } from './routes/match-preview'
import { Route as MemberRouteImport } from './routes/member'
import { Route as PerformanceRouteImport } from './routes/performance'
import { Route as PremiumRouteImport } from './routes/premium'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ResponsibleGamblingRouteImport } from './routes/responsible-gambling'
import { Route as RewardsRouteImport } from './routes/rewards'
import { Route as SafeBetsRouteImport } from './routes/safe-bets'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TrackRecordRouteImport } from './routes/track-record'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAdPerformanceRouteImport } from './routes/admin.ad-performance'
import { Route as AdminEmailDeliveriesRouteImport } from './routes/admin.email-deliveries'
import { Route as AdminI18nAuditRouteImport } from './routes/admin.i18n-audit'
import { Route as AdminPaymentsRouteImport } from './routes/admin.payments'
import { Route as AdminSignupSourcesRouteImport } from './routes/admin.signup-sources'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BlogNewsRouteImport } from './routes/blog.news'
import { Route as BlogSportsRouteImport } from './routes/blog.sports'
import { Route as ClubsIndexRouteImport } from './routes/clubs.index'
import { Route as ClubsSlugRouteImport } from './routes/clubs.$slug'
import { Route as CompetitionsIndexRouteImport } from './routes/competitions.index'
import { Route as CompetitionsSlugRouteImport } from './routes/competitions.$slug'
import { Route as CountriesIndexRouteImport } from './routes/countries.index'
import { Route as CountriesSlugRouteImport } from './routes/countries.$slug'
import { Route as DocsMcpRouteImport } from './routes/docs.mcp'
import { Route as FixturesIndexRouteImport } from './routes/fixtures.index'
import { Route as FixturesSlugRouteImport } from './routes/fixtures.$slug'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as LeaguesIndexRouteImport } from './routes/leagues.index'
import { Route as LeaguesSlugRouteImport } from './routes/leagues.$slug'
import { Route as LiveIndexRouteImport } from './routes/live.index'
import { Route as LiveSlugRouteImport } from './routes/live.$slug'
import { Route as MarketsIndexRouteImport } from './routes/markets.index'
import { Route as MarketsSlugRouteImport } from './routes/markets.$slug'
import { Route as PlayersIndexRouteImport } from './routes/players.index'
import { Route as PlayersSlugRouteImport } from './routes/players.$slug'
import { Route as PredictionsIndexRouteImport } from './routes/predictions.index'
import { Route as PredictionsLandingRouteImport } from './routes/predictions.$landing'
import { Route as PredictionsCricketTodayRouteImport } from './routes/predictions.cricket-today'
import { Route as PredictionsHorseRacingTodayRouteImport } from './routes/predictions.horse-racing-today'
import { Route as PredictionsTennisTodayRouteImport } from './routes/predictions.tennis-today'
import { Route as PredictionsTodayRouteImport } from './routes/predictions.today'
import { Route as PredictionsUfcTodayRouteImport } from './routes/predictions.ufc-today'
import { Route as TeamsSlugRouteImport } from './routes/teams.$slug'
import { Route as VsCompetitorRouteImport } from './routes/vs.$competitor'
import { Route as Char123sportChar125PredictionsIndexRouteImport } from './routes/{$sport}-predictions.index'
import { Route as Char123sportChar125PredictionsMarketRouteImport } from './routes/{$sport}-predictions.$market'
import { Route as Char123sportChar125PredictionsFixturesRouteImport } from './routes/{$sport}-predictions.fixtures'
import { Route as Char123sportChar125PredictionsTeamsRouteImport } from './routes/{$sport}-predictions.teams'
import { Route as Char123sportChar125PredictionsTodayRouteImport } from './routes/{$sport}-predictions.today'
import { Route as Char123sportChar125PredictionsTomorrowRouteImport } from './routes/{$sport}-predictions.tomorrow'
import { Route as Char123sportChar125PredictionsWeekendRouteImport } from './routes/{$sport}-predictions.weekend'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as PredictionsBookmakerSlugRouteImport } from './routes/predictions.bookmaker.$slug'
import { Route as Char123sportChar125PredictionsMatchSlugRouteImport } from './routes/{$sport}-predictions.match.$slug'
import { Route as Char123sportChar125PredictionsTeamSlugRouteImport } from './routes/{$sport}-predictions.team.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AiAccessRoute = AiAccessRouteImport.update({
            id: '/ai-access',path: '/ai-access',getParentRoute: () => rootRouteImport
          })
const AiPredictionsRoute = AiPredictionsRouteImport.update({
            id: '/ai-predictions',path: '/ai-predictions',getParentRoute: () => rootRouteImport
          })
const AnalysisRoute = AnalysisRouteImport.update({
            id: '/analysis',path: '/analysis',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BestFootballPredictionSiteRoute = BestFootballPredictionSiteRouteImport.update({
            id: '/best-football-prediction-site',path: '/best-football-prediction-site',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CreditReceiptsRoute = CreditReceiptsRouteImport.update({
            id: '/credit-receipts',path: '/credit-receipts',getParentRoute: () => rootRouteImport
          })
const ExploreRoute = ExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const HighOddsRoute = HighOddsRouteImport.update({
            id: '/high-odds',path: '/high-odds',getParentRoute: () => rootRouteImport
          })
const HistoricalOddsRoute = HistoricalOddsRouteImport.update({
            id: '/historical-odds',path: '/historical-odds',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const JackpotPredictionsRoute = JackpotPredictionsRouteImport.update({
            id: '/jackpot-predictions',path: '/jackpot-predictions',getParentRoute: () => rootRouteImport
          })
const MatchCurationRoute = MatchCurationRouteImport.update({
            id: '/match-curation',path: '/match-curation',getParentRoute: () => rootRouteImport
          })
const MatchPreviewRoute = MatchPreviewRouteImport.update({
            id: '/match-preview',path: '/match-preview',getParentRoute: () => rootRouteImport
          })
const MemberRoute = MemberRouteImport.update({
            id: '/member',path: '/member',getParentRoute: () => rootRouteImport
          })
const PerformanceRoute = PerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => rootRouteImport
          })
const PremiumRoute = PremiumRouteImport.update({
            id: '/premium',path: '/premium',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ResponsibleGamblingRoute = ResponsibleGamblingRouteImport.update({
            id: '/responsible-gambling',path: '/responsible-gambling',getParentRoute: () => rootRouteImport
          })
const RewardsRoute = RewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => rootRouteImport
          })
const SafeBetsRoute = SafeBetsRouteImport.update({
            id: '/safe-bets',path: '/safe-bets',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TrackRecordRoute = TrackRecordRouteImport.update({
            id: '/track-record',path: '/track-record',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const UploadRoute = UploadRouteImport.update({
            id: '/upload',path: '/upload',getParentRoute: () => rootRouteImport
          })
const WalletRoute = WalletRouteImport.update({
            id: '/wallet',path: '/wallet',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAdPerformanceRoute = AdminAdPerformanceRouteImport.update({
            id: '/admin/ad-performance',path: '/admin/ad-performance',getParentRoute: () => rootRouteImport
          })
const AdminEmailDeliveriesRoute = AdminEmailDeliveriesRouteImport.update({
            id: '/admin/email-deliveries',path: '/admin/email-deliveries',getParentRoute: () => rootRouteImport
          })
const AdminI18nAuditRoute = AdminI18nAuditRouteImport.update({
            id: '/admin/i18n-audit',path: '/admin/i18n-audit',getParentRoute: () => rootRouteImport
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/admin/payments',path: '/admin/payments',getParentRoute: () => rootRouteImport
          })
const AdminSignupSourcesRoute = AdminSignupSourcesRouteImport.update({
            id: '/admin/signup-sources',path: '/admin/signup-sources',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BlogNewsRoute = BlogNewsRouteImport.update({
            id: '/blog/news',path: '/blog/news',getParentRoute: () => rootRouteImport
          })
const BlogSportsRoute = BlogSportsRouteImport.update({
            id: '/blog/sports',path: '/blog/sports',getParentRoute: () => rootRouteImport
          })
const ClubsIndexRoute = ClubsIndexRouteImport.update({
            id: '/clubs/',path: '/clubs/',getParentRoute: () => rootRouteImport
          })
const ClubsSlugRoute = ClubsSlugRouteImport.update({
            id: '/clubs/$slug',path: '/clubs/$slug',getParentRoute: () => rootRouteImport
          })
const CompetitionsIndexRoute = CompetitionsIndexRouteImport.update({
            id: '/competitions/',path: '/competitions/',getParentRoute: () => rootRouteImport
          })
const CompetitionsSlugRoute = CompetitionsSlugRouteImport.update({
            id: '/competitions/$slug',path: '/competitions/$slug',getParentRoute: () => rootRouteImport
          })
const CountriesIndexRoute = CountriesIndexRouteImport.update({
            id: '/countries/',path: '/countries/',getParentRoute: () => rootRouteImport
          })
const CountriesSlugRoute = CountriesSlugRouteImport.update({
            id: '/countries/$slug',path: '/countries/$slug',getParentRoute: () => rootRouteImport
          })
const DocsMcpRoute = DocsMcpRouteImport.update({
            id: '/docs/mcp',path: '/docs/mcp',getParentRoute: () => rootRouteImport
          })
const FixturesIndexRoute = FixturesIndexRouteImport.update({
            id: '/fixtures/',path: '/fixtures/',getParentRoute: () => rootRouteImport
          })
const FixturesSlugRoute = FixturesSlugRouteImport.update({
            id: '/fixtures/$slug',path: '/fixtures/$slug',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const LeaguesIndexRoute = LeaguesIndexRouteImport.update({
            id: '/leagues/',path: '/leagues/',getParentRoute: () => rootRouteImport
          })
const LeaguesSlugRoute = LeaguesSlugRouteImport.update({
            id: '/leagues/$slug',path: '/leagues/$slug',getParentRoute: () => rootRouteImport
          })
const LiveIndexRoute = LiveIndexRouteImport.update({
            id: '/live/',path: '/live/',getParentRoute: () => rootRouteImport
          })
const LiveSlugRoute = LiveSlugRouteImport.update({
            id: '/live/$slug',path: '/live/$slug',getParentRoute: () => rootRouteImport
          })
const MarketsIndexRoute = MarketsIndexRouteImport.update({
            id: '/markets/',path: '/markets/',getParentRoute: () => rootRouteImport
          })
const MarketsSlugRoute = MarketsSlugRouteImport.update({
            id: '/markets/$slug',path: '/markets/$slug',getParentRoute: () => rootRouteImport
          })
const PlayersIndexRoute = PlayersIndexRouteImport.update({
            id: '/players/',path: '/players/',getParentRoute: () => rootRouteImport
          })
const PlayersSlugRoute = PlayersSlugRouteImport.update({
            id: '/players/$slug',path: '/players/$slug',getParentRoute: () => rootRouteImport
          })
const PredictionsIndexRoute = PredictionsIndexRouteImport.update({
            id: '/predictions/',path: '/predictions/',getParentRoute: () => rootRouteImport
          })
const PredictionsLandingRoute = PredictionsLandingRouteImport.update({
            id: '/predictions/$landing',path: '/predictions/$landing',getParentRoute: () => rootRouteImport
          })
const PredictionsCricketTodayRoute = PredictionsCricketTodayRouteImport.update({
            id: '/predictions/cricket-today',path: '/predictions/cricket-today',getParentRoute: () => rootRouteImport
          })
const PredictionsHorseRacingTodayRoute = PredictionsHorseRacingTodayRouteImport.update({
            id: '/predictions/horse-racing-today',path: '/predictions/horse-racing-today',getParentRoute: () => rootRouteImport
          })
const PredictionsTennisTodayRoute = PredictionsTennisTodayRouteImport.update({
            id: '/predictions/tennis-today',path: '/predictions/tennis-today',getParentRoute: () => rootRouteImport
          })
const PredictionsTodayRoute = PredictionsTodayRouteImport.update({
            id: '/predictions/today',path: '/predictions/today',getParentRoute: () => rootRouteImport
          })
const PredictionsUfcTodayRoute = PredictionsUfcTodayRouteImport.update({
            id: '/predictions/ufc-today',path: '/predictions/ufc-today',getParentRoute: () => rootRouteImport
          })
const TeamsSlugRoute = TeamsSlugRouteImport.update({
            id: '/teams/$slug',path: '/teams/$slug',getParentRoute: () => rootRouteImport
          })
const VsCompetitorRoute = VsCompetitorRouteImport.update({
            id: '/vs/$competitor',path: '/vs/$competitor',getParentRoute: () => rootRouteImport
          })
const Char123sportChar125PredictionsIndexRoute = Char123sportChar125PredictionsIndexRouteImport.update({
            id: '/{$sport}-predictions/',path: '/{$sport}-predictions/',getParentRoute: () => rootRouteImport
          })
const Char123sportChar125PredictionsMarketRoute = Char123sportChar125PredictionsMarketRouteImport.update({
            id: '/{$sport}-predictions/$market',path: '/{$sport}-predictions/$market',getParentRoute: () => rootRouteImport
          })
const Char123sportChar125PredictionsFixturesRoute = Char123sportChar125PredictionsFixturesRouteImport.update({
            id: '/{$sport}-predictions/fixtures',path: '/{$sport}-predictions/fixtures',getParentRoute: () => rootRouteImport
          })
const Char123sportChar125PredictionsTeamsRoute = Char123sportChar125PredictionsTeamsRouteImport.update({
            id: '/{$sport}-predictions/teams',path: '/{$sport}-predictions/teams',getParentRoute: () => rootRouteImport
          })
const Char123sportChar125PredictionsTodayRoute = Char123sportChar125PredictionsTodayRouteImport.update({
            id: '/{$sport}-predictions/today',path: '/{$sport}-predictions/today',getParentRoute: () => rootRouteImport
          })
const Char123sportChar125PredictionsTomorrowRoute = Char123sportChar125PredictionsTomorrowRouteImport.update({
            id: '/{$sport}-predictions/tomorrow',path: '/{$sport}-predictions/tomorrow',getParentRoute: () => rootRouteImport
          })
const Char123sportChar125PredictionsWeekendRoute = Char123sportChar125PredictionsWeekendRouteImport.update({
            id: '/{$sport}-predictions/weekend',path: '/{$sport}-predictions/weekend',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const PredictionsBookmakerSlugRoute = PredictionsBookmakerSlugRouteImport.update({
            id: '/predictions/bookmaker/$slug',path: '/predictions/bookmaker/$slug',getParentRoute: () => rootRouteImport
          })
const Char123sportChar125PredictionsMatchSlugRoute = Char123sportChar125PredictionsMatchSlugRouteImport.update({
            id: '/{$sport}-predictions/match/$slug',path: '/{$sport}-predictions/match/$slug',getParentRoute: () => rootRouteImport
          })
const Char123sportChar125PredictionsTeamSlugRoute = Char123sportChar125PredictionsTeamSlugRouteImport.update({
            id: '/{$sport}-predictions/team/$slug',path: '/{$sport}-predictions/team/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AiAccessRoute: AiAccessRoute,AiPredictionsRoute: AiPredictionsRoute,AnalysisRoute: AnalysisRoute,ApplyRoute: ApplyRoute,AuthRoute: AuthRoute,BestFootballPredictionSiteRoute: BestFootballPredictionSiteRoute,ContactRoute: ContactRoute,CreditReceiptsRoute: CreditReceiptsRoute,ExploreRoute: ExploreRoute,FaqRoute: FaqRoute,HighOddsRoute: HighOddsRoute,HistoricalOddsRoute: HistoricalOddsRoute,HowItWorksRoute: HowItWorksRoute,JackpotPredictionsRoute: JackpotPredictionsRoute,MatchCurationRoute: MatchCurationRoute,MatchPreviewRoute: MatchPreviewRoute,MemberRoute: MemberRoute,PerformanceRoute: PerformanceRoute,PremiumRoute: PremiumRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ProfileRoute: ProfileRoute,ResetPasswordRoute: ResetPasswordRoute,ResponsibleGamblingRoute: ResponsibleGamblingRoute,RewardsRoute: RewardsRoute,SafeBetsRoute: SafeBetsRoute,SettingsRoute: SettingsRoute,SitemapRoute: SitemapRoute,TermsRoute: TermsRoute,TrackRecordRoute: TrackRecordRoute,UnsubscribeRoute: UnsubscribeRoute,UploadRoute: UploadRoute,WalletRoute: WalletRoute,AdminAdPerformanceRoute: AdminAdPerformanceRoute,AdminEmailDeliveriesRoute: AdminEmailDeliveriesRoute,AdminI18nAuditRoute: AdminI18nAuditRoute,AdminPaymentsRoute: AdminPaymentsRoute,AdminSignupSourcesRoute: AdminSignupSourcesRoute,BlogSlugRoute: BlogSlugRoute,BlogNewsRoute: BlogNewsRoute,BlogSportsRoute: BlogSportsRoute,ClubsSlugRoute: ClubsSlugRoute,CompetitionsSlugRoute: CompetitionsSlugRoute,CountriesSlugRoute: CountriesSlugRoute,DocsMcpRoute: DocsMcpRoute,FixturesSlugRoute: FixturesSlugRoute,GuidesSlugRoute: GuidesSlugRoute,LeaguesSlugRoute: LeaguesSlugRoute,LiveSlugRoute: LiveSlugRoute,MarketsSlugRoute: MarketsSlugRoute,PlayersSlugRoute: PlayersSlugRoute,PredictionsLandingRoute: PredictionsLandingRoute,PredictionsCricketTodayRoute: PredictionsCricketTodayRoute,PredictionsHorseRacingTodayRoute: PredictionsHorseRacingTodayRoute,PredictionsTennisTodayRoute: PredictionsTennisTodayRoute,PredictionsTodayRoute: PredictionsTodayRoute,PredictionsUfcTodayRoute: PredictionsUfcTodayRoute,TeamsSlugRoute: TeamsSlugRoute,VsCompetitorRoute: VsCompetitorRoute,Char123sportChar125PredictionsMarketRoute: Char123sportChar125PredictionsMarketRoute,Char123sportChar125PredictionsFixturesRoute: Char123sportChar125PredictionsFixturesRoute,Char123sportChar125PredictionsTeamsRoute: Char123sportChar125PredictionsTeamsRoute,Char123sportChar125PredictionsTodayRoute: Char123sportChar125PredictionsTodayRoute,Char123sportChar125PredictionsTomorrowRoute: Char123sportChar125PredictionsTomorrowRoute,Char123sportChar125PredictionsWeekendRoute: Char123sportChar125PredictionsWeekendRoute,AdminIndexRoute: AdminIndexRoute,BlogIndexRoute: BlogIndexRoute,ClubsIndexRoute: ClubsIndexRoute,CompetitionsIndexRoute: CompetitionsIndexRoute,CountriesIndexRoute: CountriesIndexRoute,FixturesIndexRoute: FixturesIndexRoute,GuidesIndexRoute: GuidesIndexRoute,LeaguesIndexRoute: LeaguesIndexRoute,LiveIndexRoute: LiveIndexRoute,MarketsIndexRoute: MarketsIndexRoute,PlayersIndexRoute: PlayersIndexRoute,PredictionsIndexRoute: PredictionsIndexRoute,Char123sportChar125PredictionsIndexRoute: Char123sportChar125PredictionsIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,PredictionsBookmakerSlugRoute: PredictionsBookmakerSlugRoute,Char123sportChar125PredictionsMatchSlugRoute: Char123sportChar125PredictionsMatchSlugRoute,Char123sportChar125PredictionsTeamSlugRoute: Char123sportChar125PredictionsTeamSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)